import { metricKeys } from '@pulse/metrics';

export const deviceMetrics = [metricKeys.BadUniqueDevices, metricKeys.GoodUniqueDevices];

export const viewerMetrics = [metricKeys.BadUniqueViewers, metricKeys.GoodUniqueViewers];
